import CreatePlayListForm from "modules/playlist/CreatePlayListForm";

export const forms = {
  create_playlist: <CreatePlayListForm></CreatePlayListForm>,
};
